export const SEARCH_GET_SEARCH_RESULTS = "SEARCH_GET_SEARCH_RESULTS";
export const SEARCH_GET_SEARCH_REQUESTED =
  "SEARCH_GET_SEARCH_RESULTS_REQUESTED";
export const SEARCH_GET_SEARCH_RESULTS_SUCCESS =
  "SEARCH_GET_SEARCH_RESULTS_SUCCESS";
export const SEARCH_GET_SEARCH_RESULTS_FAILED =
  "SEARCH_GET_SEARCH_RESULTS_FAILED";
export const SEARCH_GET_SEARCH_RESULTS_CLEAR =
  "SEARCH_GET_SEARCH_RESULTS_CLEAR";
